<template>
    <Header v-if="isLoggedIn && isReportConfirmation && isEmulsionReportConfirmation"></Header>
    <InfoDialog id="authDialog" :visible="isModalVisibile" header="Nieautoryzowany token" :content="errorMessage"
                actionLabel="Zaloguj się" @close="redictToLogin" @accept="redictToLogin">
    </InfoDialog>

    <InfoDialog id="cancelRoutingDialog" :visible="routingCancelModal.isVisible" :header="routingCancelModal.header"
                :content="routingCancelModal.content"
                :actionLabel="routingCancelModal.label" @close="closeRoutingModal" @accept="closeRoutingModal">
    </InfoDialog>

    <Toast />

    <DynamicDialog />

    <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import Header from'./views/Header';
import {onMounted, ref} from "vue";
import {axiosInstance} from "../../core/api/instance";
import {useRouter} from "vue-router";
import InfoDialog from "./components/InfoDialog";
import Toast from "primevue/toast";
import {useToast} from "primevue/usetoast";
import DynamicDialog from "primevue/dynamicdialog";

export default {
    name: 'App',

    components: {
        Header,
        InfoDialog,
        Toast,
        DynamicDialog
    },
    setup() {
        const toast = useToast();
        const isModalVisibile = ref(false);
        const errorMessage = ref('');
        const router = useRouter();
        const routingCancelModal = ref({
            isVisible: false,
            header: '',
            content: '',
            label: '',
            redirectTo: ''
        });

        onMounted(function() {
            // === DEFAULT ERROR CALLBACK FUNCTION FOR WHOLE ADMIN SECTION ===
            axiosInstance.defaults.errorHandler = {
                errorCallbackFunction: (errorObj) => {
                    console.error('error', errorObj);
                    isModalVisibile.value = true;
                    errorMessage.value = errorObj?.response?.data?.error ?? errorObj?.message;
                },
                errorToast: (errorObj) => {
                    console.error('error', errorObj);
                    toast.add({severity: 'error', summary: errorObj?.response?.data?.error ?? errorObj?.message, life: 5000});
                }
            };

            axiosInstance.defaults.cancelRouting = {
                reportEdition: function (to) {
                    routingCancelModal.value.isVisible = true;
                    routingCancelModal.value.content = 'Budowa dla tego raportu jest nieaktywna, więc nie można przejść do edycji takiego raportu.';
                    routingCancelModal.value.header = 'Brak możliwości edycji raportu.';
                    routingCancelModal.value.label = 'Przejdź do listy raportów';
                    routingCancelModal.value.redirectTo = to;
                }
            };
        });

        const closeRoutingModal = () => {
            routingCancelModal.value.isVisible = false;
            router.push(routingCancelModal.value.redirectTo);
        };

        const redictToLogin = () => {
            isModalVisibile.value = false;
            router.push('/login');
        }

        return { isModalVisibile, errorMessage, routingCancelModal, closeRoutingModal, redictToLogin }
    },
    data() {
        return {
            isLoggedIn: false,
            isReportConfirmation: false,
            isEmulsionReportConfirmation: false
        }
    },
    watch: {
        '$route': function(value) {
            this.isLoggedIn = value.name !== 'Login';
            this.isReportConfirmation = value.name !== 'ReportConfirmation';
            this.isEmulsionReportConfirmation = value.name !== 'EmulsionReportConfirmation';
        }
    },
}
</script>

<style lang="scss">
@import 'imports';
#app {
    text-align: center;
    color: #2c3e50;
}

body {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

</style>
